import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { PDPHero } from "../apps/configurator/PDPHero";
import { GalleryBlock } from "../components/GalleryBlock";
import { ValuePropsBarBlock } from "../components/ValuePropsBarBlock";
import { isoImageURL } from "../models/nominals";

type Props = Immutable<templates.ProductHeroAssemblyTemplate>;

export const Template = (props: Props): React.JSX.Element | null => {
    if (!props.page.product_hero) {
        return null;
    }
    return (
        <StreamField
            tagName={React.Fragment}
            value={props.page.product_hero.value}
            components={{
                gallery_block: (block) => (
                    <GalleryBlock
                        blockData={block.value}
                        defaultThumbnail={props.default_thumbnail}
                        initialGalleryIndex={
                            block.id
                                ? (props.initial_gallery_indexes[block.id] ??
                                  null)
                                : null
                        }
                    />
                ),
                legacy_product_hero: (block) => (
                    <PDPHero
                        defaultBackgroundImage={
                            block.value.hero_image
                                ? isoImageURL.wrap(block.value.hero_image.url)
                                : null
                        }
                        defaultMobileBackgroundImage={
                            block.value.mobile_hero_image
                                ? isoImageURL.wrap(
                                      block.value.mobile_hero_image.url,
                                  )
                                : null
                        }
                        defaultImageTitle={block.value.hero_image?.title ?? ""}
                    />
                ),
                value_prop_bar: (block) => (
                    <ValuePropsBarBlock valuePropsData={block.value} />
                ),
            }}
        />
    );
};
